import { getAxiosClient } from "../../axios-client";
import { WarehousesInsuranceBody, WarehousesInsuranceResponse } from "./types";

const axiosClient = getAxiosClient();
export const addWarehousesInsurance = async (body: WarehousesInsuranceBody) => {
    return await axiosClient.ax
    .post<WarehousesInsuranceResponse>("/WarehousesInsurance/Add", body,{headers: {'content-type': 'multipart/form-data'}})
  };
  
